import { useEntityStore } from '../../stores/entityStore';
import { useAuthStore } from '../../stores/authStore';

const ENTITY_COLORS: Record<string, string> = {
  ml_order: '#f97316',
  ml_shipment: '#3b82f6',
  tracking: '#06b6d4',
  po_number: '#a855f7',
  asin: '#14b8a6',
  amazon_order: '#eab308',
  wh_item: '#22c55e',
};

interface EntityLinkProps {
  type: string;
  value: string | number;
  sellerId?: number;
  label?: string;
  className?: string;
}

export function EntityLink({ type, value, sellerId, label, className = '' }: EntityLinkProps) {
  const open = useEntityStore(s => s.open);
  const user = useAuthStore(s => s.user);
  const color = ENTITY_COLORS[type] || '#9ca3af';
  const displayValue = label || String(value);
  const sid = sellerId || user?.tenant_id || 1;

  return (
    <span
      onClick={(e) => { e.stopPropagation(); open({ type, value: String(value), sellerId: sid }); }}
      className={`font-mono cursor-pointer hover:underline inline-flex items-center gap-0.5 ${className || 'text-sm'}`}
      style={{ color }}
      title={`${type}: ${value}`}
    >
      {type === 'ml_order' && '#'}
      {displayValue}
    </span>
  );
}
